import { DURATION_OPTIONS } from 'constants/forms';
import { SelectOption, MediaType } from 'models/forms';
import { MediaFile, AudioOption, StorageKey } from 'models';
import { getStorageFolder, getFileName } from './firebase';

export const getEnabledText = (isEnabled: boolean): string => {
  return isEnabled ? 'On' : 'Off';
};

export const getAvailableDurations = (durations: number[]): SelectOption[] => {
  const availableDurations = DURATION_OPTIONS.filter(
    (option) => !durations.includes(option.value),
  );
  return availableDurations;
};

export const getAvailableOrders = (
  orders: number[],
  isEdit: boolean,
): SelectOption[] => {
  const allOrders = [...orders];
  if (!isEdit) {
    const newIndex = allOrders[allOrders.length - 1] + 1;
    allOrders.push(newIndex);
  }
  const availableOrders = allOrders.map((order) => ({
    value: order,
    label: order.toString(),
  }));
  return availableOrders;
};

export const convertToMediaFile = (url: string, type: MediaType): MediaFile => {
  const folder = getStorageFolder(type);
  const splittedUrl = url.split(`/${folder.toString()}/`);
  const fileName = getFileName(splittedUrl[1]);
  return { name: fileName, file: url };
};

export const getDurations = (options: AudioOption[]): number[] => {
  const durations = options.map((option) => option.duration);
  return durations;
};

export const getRPPStorageKey = (isRequired: boolean): StorageKey => {
  const key = isRequired
    ? StorageKey.ProgramsTableRequiredRPP
    : StorageKey.ProgramsTableNoRequiredRPP;
  return key;
};

export const getPageStorageKey = (isRequired: boolean): StorageKey => {
  const key = isRequired
    ? StorageKey.ProgramsTableRequiredPage
    : StorageKey.ProgramsTableNoRequiredPage;
  return key;
};
